import { type Token } from './token';
import { type Profile } from './profile';

export enum OnboardResult {
    EXISTS = "EXISTS",       // user was found in users table with clerkId previously populated
    FAILED = "FAILED",
    MIGRATED = "MIGRATED",   // migrated from Auth0
    CREATED = "CREATED"      // brand new user
};

export enum AuthorizationStatus {
    AUTHORIZED = "AUTHORIZED",
    NOT_AUTHORIZED = "NOT_AUTHORIZED"
}

export interface AuthorizationResponse {
    status: AuthorizationStatus,
    token?: Token,
    profile?: Profile,
    onboardResult?: OnboardResult
}
